<template>
    <v-row no-gutters>
        <v-col cols="12" v-if="!loading">
            <v-sheet class="card-rounded">
                <FirstStepStatus
                    v-if="currentStep == 1"
                    :applicantInfo="applicantInfo"
                    :getStatusState="getStatusState"
                    :getButtonState="getButtonState"
                    @onConfirmStatus="onConfirmStatus"
                ></FirstStepStatus>
                <SecondStepStatus
                    v-else-if="currentStep == 2"
                    :applicantInfo="applicantInfo"
                    :getStatusState="getStatusState"
                    :getButtonState="getButtonState"
                    @onConfirmStatus="onConfirmStatus"
                ></SecondStepStatus>
                <!-- Step 3-5 -->
                <ThirdStepStatus
                    v-else-if="currentStep >= 3"
                    :currentStep="currentStep"
                    :applicantInfo="applicantInfo"
                    :getStatusState="getStatusState"
                    :getButtonState="getButtonState"
                    @onConfirmStatus="onConfirmStatus"
                ></ThirdStepStatus>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import FirstStepStatus from "@/components/admin/Candidates/Applicant/Status/FirstStepStatus.vue";
import SecondStepStatus from "@/components/admin/Candidates/Applicant/Status/SecondStepStatus.vue";
import ThirdStepStatus from "@/components/admin/Candidates/Applicant/Status/ThirdStepStatus.vue";
import { RegistrationStatusEnum } from "@/constants";
import i18n from "@/i18n";
import * as services from "@/services";

export default {
    components: {
        FirstStepStatus,
        SecondStepStatus,
        ThirdStepStatus,
    },
    props: {
        applicantInfo: Object,
        currentStep: String,
        applicantId: Number,
        paymentEvidencesInfo: Array,
    },
    mounted() {
        this.loading = true;
        this.retrievedData();
        this.loading = false;
    },
    computed: {
        getStatusState() {
            let state = {
                register: {
                    icon: "mdi-plus-circle",
                    color: "#7FA2CC",
                    text: i18n.t('message.stepperBar.register'),
                    value: "register",
                },
                successful_payment: {
                    icon: "mdi-currency-usd",
                    color: "#00C487",
                    text: i18n.t('message.step3.status.successfulPayment'),
                    value: "successful_payment",
                },
                pending_payment: {
                    icon: "mdi-currency-usd-off",
                    color: "#FF544A",
                    text: i18n.t('message.step2.pending_payment'),
                    value: "pending_payment",
                },
                exam_unauthorize: {
                    icon: "mdi-close-circle",
                    color: "#FF544A",
                    text: i18n.t('message.step3.status.noQualified'),
                    value: "exam_unauthorize",
                },
                exam_authorize: {
                    icon: "mdi-check-circle",
                    color: "#00C487",
                    text: i18n.t('message.step3.status.qualified'),
                    value: "exam_authorize",
                },
                exam_authorize_by_system: {
                    icon: "mdi-check-circle",
                    color: "#00C487",
                    text: i18n.t('message.step3.status.qualified'),
                    value: "exam_authorize",
                },
                not_qualify: {
                    icon: "mdi-close-circle",
                    color: "#FF544A",
                    text: i18n.t('message.step4.topic.notPass'),
                    value: "not_qualify",
                },
                pending_confirmation: {
                    icon: "mdi-clock",
                    color: "#7FA2CC",
                    text: i18n.t('message.adminPage.waitingConfirmation'),
                    value: "pending_confirmation",
                },
                rejection: {
                    icon: "mdi-close-circle",
                    color: "#FF544A",
                    text: i18n.t('message.step4.status.waiver'),
                    value: "rejection",
                },
                successful_confirmation: {
                    icon: "mdi-clock",
                    color: "#7FA2CC",
                    text: i18n.t('message.adminPage.waitingConfirmation'),
                    value: "successful_confirmation",
                },
                successful_confirmation_detail: {
                    icon: "mdi-check-circle",
                    color: "#FF9800",
                    text: i18n.t('message.formSummit.confirm'),
                    value: "successful_confirmation_detail",
                },
                successful_enrollment: {
                    icon: "mdi-shield-check",
                    color: "#00C487",
                    text: i18n.t('message.adminPage.successfulInitiation'),
                    value: "successful_enrollment",
                },
            };
            if (state[this.applicantInfo?.registrationStatus?.toLowerCase()]) {
                return state[
                    this.applicantInfo?.registrationStatus?.toLowerCase()
                ];
            }
            return {
                icon: "mdi-shield-check",
                color: "#7FA2CC",
                text: i18n.t('message.adminPage.notFoundStatus'),
                value: "status_not_found",
            };
        },
        getButtonState() {
            let disableState = {
                register: {
                    submit: false,
                    cancel: false,
                },
                pending_payment: {
                    submit: this.paymentEvidencesInfo.length > 0 ? false : true,
                    cancel: false,
                },
                successful_payment: {
                    submit: false,
                    cancel: false,
                },
                exam_authorize: {
                    submit: false,
                    cancel: false,
                },
                exam_authorize_by_system: {
                    submit: false,
                    cancel: false,
                },
                exam_unauthorize: {
                    submit: true,
                    cancel: false,
                },
                not_qualify: {
                    submit: true,
                    cancel: true,
                },
                pending_confirmation: {
                    submit: false,
                    cancel: false,
                },
                rejection: {
                    submit: true,
                    cancel: false,
                },
                successful_confirmation: {
                    submit: true,
                    cancel: false,
                },
                successful_confirmation_detail: {
                    submit: true,
                    cancel: false,
                },
                successful_enrollment: {
                    submit: true,
                    cancel: false,
                },
                // fallback if not hit
                default: {
                    submit: true,
                    cancel: true,
                },
            };
            return {
                submit: {
                    color: "primary",
                    text: i18n.t('message.adminPage.status.answer.qualified'),
                    disable:
                        disableState[
                            this.applicantInfo?.registrationStatus?.toLowerCase() ??
                                "default"
                        ].submit,
                },
                cancel: {
                    color: "error",
                    text: i18n.t('message.adminPage.status.answer.notQualified'),
                    disable:
                        disableState[
                            this.applicantInfo?.registrationStatus?.toLowerCase() ??
                                "default"
                        ].cancel,
                },
            };
        },
    },

    data() {
        return {
            applicant: {},
            loading: false,
        };
    },
    methods: {
        showAlert(status, text) {
            this.$emit("showAlert", status, text);
        },
        closeAlert() {
            this.$emit("closeAlert");
        },
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        async onConfirmStatus(action, params = null) {
            try {
                let alertInfo = {
                    accept: {
                        title: i18n.t('message.adminPage.modal.qualifiedModal'),
                        text: i18n.t('message.adminPage.modal.qualifiedModalContent.head')+ `${this.applicant?.fullName}`+ i18n.t('message.adminPage.modal.qualifiedModalContent.tail'),
                        icon: "success",
                        confirmColor: "#FF9800",
                        iconClass: "swal2-warning-bg",
                    },
                    reject: {
                        title: i18n.t('message.adminPage.modal.notQualifiedModal'),
                        text: i18n.t('message.adminPage.modal.notQualifiedModalContent.head')+ `${this.applicant?.fullName}`+ i18n.t('message.adminPage.modal.notQualifiedModalContent.tail'),
                        icon: "warning",
                        confirmColor: "#FF544A",
                        iconClass: "swal2-warning-bg",
                    },
                    pass_exam: {
                        title: i18n.t('message.adminPage.modal.passedModal'),
                        text: i18n.t('message.adminPage.modal.passedModalContent.head')+`${this.applicant?.fullName}`+i18n.t('message.adminPage.modal.passedModalContent.tail'),
                        icon: "success",
                        confirmColor: "#FF9800",
                        iconClass: "swal2-succes-bg",
                    },
                    fail_exam: {
                        title: i18n.t('message.adminPage.modal.notPassedModal'),
                        text: i18n.t('message.adminPage.modal.passedModalContent.head')+`${this.applicant?.fullName}`+i18n.t('message.adminPage.modal.passedModalContent.tail'),
                        icon: "warning",
                        confirmColor: "#FF544A",
                        iconClass: "swal2-warning-bg",
                    },
                    confirm_enrollment: {
                        title: i18n.t('message.adminPage.modal.initiationModal'),
                        text: i18n.t('message.adminPage.modal.initiationModalContent.head')+`${this.applicant?.fullName}`+i18n.t('message.adminPage.modal.initiationModalContent.tail'),
                        icon: "success",
                        confirmColor: "#FF9800",
                        iconClass: "swal2-succes-bg",
                    },
                    change_exam_result: {
                        title: i18n.t('message.adminPage.modal.qualifiedModal'),
                        text: i18n.t('message.adminPage.modal.qualifiedModalContent.head')+ `${this.applicant?.fullName}`+ i18n.t('message.adminPage.modal.qualifiedModalContent.tail'),
                        icon: "success",
                        confirmColor: "#FF9800",
                        iconClass: "swal2-warning-bg",
                    },
                };
                let res = await this.$swal.fire({
                    icon: alertInfo[action].icon == "success"? "":"warning",
                    imageUrl: alertInfo[action].icon == "success"? require('@/assets/right.svg'):'',
                    imageHeight: 55,
                    title: alertInfo[action].title,
                    text: alertInfo[action].text,
                    iconColor:
                        alertInfo[action].text == "success"
                            ? "#00C487"
                            : "#FF544A",
                    showCancelButton: true,
                    confirmButtonText: i18n.t('message.adminPage.button.confirm'),
                    cancelButtonText: i18n.t('message.adminPage.button.cancel'),
                    reverseButtons: true,
                    confirmButtonColor: alertInfo[action].confirmColor,
                    cancelButtonColor: "#FF9800",
                    customClass: {
                        icon: alertInfo[action].iconClass,
                    },
                    showCloseButton: true,
                });
                if (res.isConfirmed) {
                    // if 200 success
                    this.showAlert("success", i18n.t('message.adminPage.successfulEdit'));
                    this.checkUpdateApplicantStatus(
                        action,
                        this.applicant.registrationStatus,
                        params
                    );
                }
            } catch (error) {
                console.log(error);
                this.showAlert("error", error.response?.data?.message);
            }
        },
        async checkUpdateApplicantStatus(action, applicantStatus, params) {
            if (action == "accept") {
                if (
                    applicantStatus == RegistrationStatusEnum.REGISTER ||
                    applicantStatus == RegistrationStatusEnum.SUCCESSFUL_PAYMENT
                ) {
                    // update status from register/successful_payment -> exam_authorize
                    await this.updateApplicantStatus(
                        RegistrationStatusEnum.EXAM_AUTHORIZE,
                        null
                    );
                }
            } else if (action == "reject") {
                if (
                    applicantStatus == RegistrationStatusEnum.REGISTER ||
                    applicantStatus == RegistrationStatusEnum.PENDING_PAYMENT ||
                    applicantStatus == RegistrationStatusEnum.SUCCESSFUL_PAYMENT
                ) {
                    // update status from register/pending_payment/successful_payment -> exam_unauthorize
                    await this.updateApplicantStatus(
                        RegistrationStatusEnum.EXAM_UNAUTHORIZE,
                        null
                    );
                }
            } else if (action == "confirm_enrollment") {
                if (
                    applicantStatus ==
                    RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL
                ) {
                    // update status from Successful_confirmation_detail -> successful_enrollment
                    await this.updateApplicantStatus(
                        RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT,
                        "current"
                    );
                }
            } else if (action == "pass_exam") {
                if (
                    applicantStatus == RegistrationStatusEnum.EXAM_AUTHORIZE ||
                    applicantStatus ==
                        RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM
                ) {
                    // update status from Successful_confirmation_detail -> successful_enrollment
                    await this.updateExamResult(params);
                    await this.updateApplicantStatus(
                        RegistrationStatusEnum.PENDING_CONFIRMATION,
                        params.result.result_type
                    );
                }
            } else if (action == "fail_exam") {
                if (
                    applicantStatus == RegistrationStatusEnum.EXAM_AUTHORIZE ||
                    applicantStatus ==
                        RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM
                ) {
                    // update status from Successful_confirmation_detail -> successful_enrollment
                    await this.updateExamResult(params);
                    await this.updateApplicantStatus(
                        RegistrationStatusEnum.NOT_QUALIFY,
                        params.result.result_type
                    );
                }
            } else if (action == "change_exam_result") {
                // update status from exam_unauthorize -> exam_unauthorize
                if (
                    applicantStatus ==
                    RegistrationStatusEnum.EXAM_UNAUTHORIZE
                ) {
                    await this.updateApplicantStatus(
                        RegistrationStatusEnum.EXAM_AUTHORIZE,
                        null
                    );
                }
            }
        },
        async updateExamResult(params) {
            try {
                await services.updateStudentExamResult(
                    this.applicantId,
                    params
                );
            } catch (err) {
                console.log(err);
            }
        },
        async updateApplicantStatus(targetStatus, resultType = null) {
            try {
                await services.updateStudentRegistrationStatus({
                    id: this.applicantId,
                    registration_status: targetStatus,
                    result_type: resultType,
                });
                setTimeout(() => {
                    location.reload();
                }, 3000);
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>

<style scoped lang="scss">

.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text-prompt {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
